const DOTS = [
  { x: 66, y: 74, label: "Noord-Holland" },
  { x: 56, y: 118, label: "Zuid-Holland" },
  { x: 90, y: 100, label: "Midden-Nederland" },
  { x: 132, y: 48, label: "Groningen" },
  { x: 110, y: 150, label: "Noord-Brabant" },
  { x: 136, y: 186, label: "Limburg" },
  { x: 128, y: 96, label: "Oost-Nederland" },
];

export const NLMap = () => (
  <svg
    viewBox="0 0 200 240"
    className="h-auto w-full max-w-sm"
    role="img"
    aria-label="Gestileerde kaart van Nederland met landelijke dekking"
  >
    <path
      d="M148,28 L152,52 L148,70 L156,92 L150,116 L158,140 L146,158 L152,176 L144,206 L134,224 L126,214 L130,188 L122,170 L128,156 L108,162 L88,158 L70,166 L54,158 L34,164 L22,156 L36,148 L24,142 L40,136 L30,128 L48,118 L58,96 L64,72 L60,52 L68,36 L80,30 L92,24 L110,18 L128,20 L142,22 Z"
      fill="#10232F"
      stroke="#2B9FD7"
      strokeOpacity="0.5"
      strokeWidth="1.2"
    />
    <path
      d="M148,28 L152,52 L148,70 L156,92 L150,116 L158,140 L146,158 L152,176 L144,206 L134,224"
      fill="none"
      stroke="#62C3F0"
      strokeOpacity="0.25"
      strokeWidth="0.8"
      className="tech-line"
    />
    {DOTS.map((dot) => (
      <g key={dot.label}>
        <circle cx={dot.x} cy={dot.y} r="3" fill="#62C3F0">
          <title>{dot.label}</title>
        </circle>
        <circle cx={dot.x} cy={dot.y} r="7" fill="none" stroke="#62C3F0" strokeOpacity="0.4" strokeWidth="1" className="hotspot-ring" />
      </g>
    ))}
    <text x="14" y="230" fill="#CBD3D9" fillOpacity="0.7" fontSize="9" fontFamily="Sora, sans-serif" letterSpacing="2">
      LANDELIJKE DEKKING
    </text>
  </svg>
);
